const StarRating = ({ rating }) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
  
    const fullStar = (
      <svg className="w-4 h-4" style={{ fill: '#F99D1D' }} viewBox="0 0 20 20" key={Math.random()}>
        <path d="M10 15l-5.878 3.09L5.5 12.18 1 7.91l6.06-.88L10 2l2.94 5.03 6.06.88-4.5 4.27 1.378 5.91z" />
      </svg>
    );
  
    const halfStar = (
        <svg className="w-4 h-4" viewBox="0 0 20 20" key={Math.random()}>
          <defs>
            <linearGradient id="half-grad">
              <stop offset="50%" stopColor="#F99D1D" />
              <stop offset="50%" stopColor="#D1D5DB" /> {/* Tailwind gray-300 */}
            </linearGradient>
          </defs>
          <path
            fill="url(#half-grad)"
            d="M10 15l-5.878 3.09L5.5 12.18 1 7.91l6.06-.88L10 2l2.94 5.03 6.06.88-4.5 4.27 1.378 5.91z"
          />
        </svg>
      );
      
  
    const emptyStar = (
      <svg className="w-4 h-4 fill-gray-300" viewBox="0 0 20 20" key={Math.random()}>
        <path d="M10 15l-5.878 3.09L5.5 12.18 1 7.91l6.06-.88L10 2l2.94 5.03 6.06.88-4.5 4.27 1.378 5.91z" />
      </svg>
    );
  
    const stars = [
      ...Array(fullStars).fill(fullStar),
      ...(hasHalfStar ? [halfStar] : []),
      ...Array(emptyStars).fill(emptyStar),
    ];
  
    return (
      <div className="flex items-center flex-row">
        <div className="flex items-center space-x-0.5">
            {stars}
        </div>
        <span className="text-[#1A0180] text-[14px] ml-4">{rating}</span>
      </div>
    );
  };
export default StarRating